/**
 * Defines the values for the action that triggers the `fileOpen` event in the File Manager.
 * ```props
 * DoubleClick :- The `fileOpen` event is triggered when a file or folder is opened through a mouse double-click or touch double-tap action.
 * KeyboardEnter :- The `fileOpen` event is triggered when a file or folder is opened through the Enter key press.
 * ContextMenu :- The `fileOpen` event is triggered when the Open action is performed through the context menu.
 * DragAndDrop :- The `fileOpen` event is triggered when folder navigation occurs as part of a drag-and-drop operation.
 * ```
 */
export var FileOpenAction;
(function (FileOpenAction) {
    /**
     * Specifies that the `fileOpen` event is triggered through a mouse double-click or touch double-tap action.
     */
    FileOpenAction["DoubleClick"] = "DoubleClick";
    /**
     * Specifies that the `fileOpen` event is triggered through the Enter key press.
     */
    FileOpenAction["KeyboardEnter"] = "KeyboardEnter";
    /**
     * Specifies that the `fileOpen` event is triggered through the Open option in the context menu.
     */
    FileOpenAction["ContextMenu"] = "ContextMenu";
    /**
     * Specifies that the `fileOpen` event is triggered through a drag-and-drop folder navigation action.
     */
    FileOpenAction["DragAndDrop"] = "DragAndDrop";
})(FileOpenAction || (FileOpenAction = {}));
